<div class="homepage-greeting">
  @if (user$ | async; as user) {
    <h1>{{
      'cartAdministration.miniLogin.userGreeting' | cxTranslate: { name: user.name | formatUsername }
    }}</h1>
  }
</div>